document.addEventListener("DOMContentLoaded", function () {

    const bookingBar = document.getElementById('bookBarForm');

    if (!bookingBar) {
        return;
    }

    var checkOutPicker = new Pikaday({
        field: document.getElementById('bookBarCheckOut'),
        onSelect: function () {
            document.getElementById('bookBarCheckOut').innerText = this.toString();
        }
    });

    var checkInPicker = new Pikaday({
        field: document.getElementById('bookBarCheckIn'),
        minDate: new Date(),
        onSelect: function () {
            document.getElementById('bookBarCheckIn').innerText = this.toString();
            var checkInDate = this.getDate();
            var checkOutDate = checkOutPicker.getDate();
            checkInDate.setDate(checkInDate.getDate() + 1);
            checkOutPicker.setMinDate(new Date(checkInDate));

            if (!checkOutDate || checkOutDate < checkInDate) {
                checkOutPicker.setDate(null);
                checkOutPicker.show();
            }
        }
    });

    let childrenGroupField = document.getElementById('bookBarChildrenGroup');
    let childrenField = document.getElementById('bookBarChildren');
    let infantsField = document.getElementById('bookBarInfants');
    let childrenInfants = document.getElementById('childrenInfants');

    const maxCount = 3;

    function populateSelect(selectElement, maxOptions) {
        // Remove options from 1 to 3
        for (let i = selectElement.options.length - 1; i >= 1; i--) {
            selectElement.remove(i);
        }

        for (let i = 1; i <= maxOptions; i++) {
            let option = document.createElement('option');
            option.value = i;
            option.text = i;
            selectElement.appendChild(option);
        }
    }

    function updateOptions() {
        let childrenCount = parseInt(childrenField.value);
        let infantsCount = parseInt(infantsField.value);
        let remainingForInfants = maxCount - childrenCount;
        let remainingForChildren = maxCount - infantsCount;

        populateSelect(infantsField, remainingForInfants);
        populateSelect(childrenField, remainingForChildren);

        // Set selected values back to the selects if possible
        if (childrenCount <= remainingForChildren) {
            childrenField.value = childrenCount;
        } else {
            childrenField.value = 0; // Reset to 0 if out of range
        }
        if (infantsCount <= remainingForInfants) {
            infantsField.value = infantsCount;
        } else {
            infantsField.value = 0; // Reset to 0 if out of range
        }

        let childrenCountFinal = parseInt(childrenField.value);
        let infantsCountFinal = parseInt(infantsField.value);

        childrenGroupField.innerHTML = childrenCountFinal + infantsCountFinal;
    }
    function childrenGroupFieldClicked() {
        if (childrenInfants.classList.contains("d-none")) {
            childrenInfants.classList.remove("d-none");

        }
        else {
            childrenInfants.classList.add("d-none");
        }

    }
    populateSelect(childrenField, maxCount);
    populateSelect(infantsField, maxCount);

    childrenField.addEventListener('change', updateOptions);
    infantsField.addEventListener('change', updateOptions);
    childrenGroupField.addEventListener('click', childrenGroupFieldClicked);

   
    function formatDate(dateString) {
        let date = new Date(dateString);
        let year = date.getFullYear();
        let month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        let day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    document.getElementById('bookBarForm').addEventListener('change', function () {
        var errors = document.getElementsByClassName('error');

        if (errors) {
            for (let i = 0; i < errors.length; i++) {
                if (!(errors[i].classList.contains('d-none'))) {

                    errors[i].classList.add('d-none');
                }
            }
        }
    });

    document.getElementById('bookBarForm').addEventListener('submit', function (e) {
        e.preventDefault();

        let hotel = document.getElementById('bookBarHotel').value;
        let checkIn = document.getElementById('bookBarCheckIn').value;
        let checkOut = document.getElementById('bookBarCheckOut').value;
        let adults = document.getElementById('bookBarAdults').value;
        let children = document.getElementById('bookBarChildren').value;
        let infants = document.getElementById('bookBarInfants').value;

        let formattedCheckInDate = formatDate(checkIn);

        let baseUrl = 'https://www.englishlakeshotels.co.uk/Bookings/Results_Screen.aspx';
        let queryParams = [];

        queryParams.push(`mini=true`);

        if (hotel) {
            queryParams.push(`HotelCode=${encodeURIComponent(hotel)}`);
        }
        else {
            document.getElementById('errorHotel').classList.remove('d-none');

            return;
        }

        if (checkIn && checkOut) {
            let checkInDate = new Date(checkIn);
            let checkOutDate = new Date(checkOut);

            const timeDifference = checkOutDate - checkInDate;

            // Convert the time difference to nights
            var nights = timeDifference / (1000 * 60 * 60 * 24);

            queryParams.push(`from=${encodeURIComponent(formattedCheckInDate)}`);
            queryParams.push(`nights=${encodeURIComponent(nights)}`);
        }

        else {
            document.getElementById('errorDates').classList.remove('d-none');

            return;
        }

        if (adults && adults > 0) {
            queryParams.push(`adults=${encodeURIComponent(adults)}`);
        }
        else {
            document.getElementById('errorAdults').classList.remove('d-none');

            return;
        }

        if (children) {
            queryParams.push(`children=${encodeURIComponent(children)}`);
        }

        if (infants) {
            queryParams.push(`infants=${encodeURIComponent(infants)}`);
        }

        if ((parseInt(adults) + parseInt(children) + parseInt(infants)) > 4) {
            document.getElementById('errorGuests').classList.remove('d-none');

            return;
        }

        queryParams.push(`cs=true`);

        let fullUrl = `${baseUrl}?${queryParams.join('&')}`;

        window.open(fullUrl, '_blank');
    });
});